<template>
    <div class="offcanvas offcanvas-end w-1/3" data-bs-scroll="true" data-bs-backdrop="true" tabindex="-1" id="contractModal" aria-labelledby="contractModal">
        <div class="offcanvas-header">
            <h4 class="offcanvas-title">{{ title }}</h4>
            <button type="button" class="btn-close text-reset text-xs" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pt-0">
            <div class="row">
                <div class="col-6">
                    <ContractStatus :userId="data.employee" v-if="! loading && data.employee" />
                </div>
                <div :class="{ 'col-6': showHistory, 'col-12': ! showHistory }">
                    <div class="d-flex justify-content-center" v-if="loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
                        </div>
                    </div>
                    <ContractForm ref="form" v-else-if="['create', 'extend'].includes(action)" />
                    <EditContractForm ref="form" v-else-if="action === 'edit'" />
                    <TerminateContractForm ref="form" v-else-if="action === 'terminate'" />
                    <WorkingHoursForm ref="form" v-else-if="action === 'working-hours'" />
                </div>
            </div>
        </div>
        <div class="modal-footer bg-surface-secondary" v-if="action">
            <button type="button" class="btn btn-sm btn-neutral" data-bs-dismiss="offcanvas">
                {{ $trans.get('__JSON__.Cancel') }}
            </button>
            <button type="button" class="btn btn-sm" :class="submitClass" @click="submit" :disabled="submitting">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="submitting"></span>
                <span v-else>{{ submitButton }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import EditContractForm from "./forms/EditContractForm.vue";
import TerminateContractForm from "./forms/TerminateContractForm.vue";
import ContractForm from "./forms/ContractForm.vue";
import WorkingHoursForm from "./forms/WorkingHoursForm.vue";
import RequestHandler from "../mixins/RequestHandler";
import ContractStatus from "./ContractStatus.vue";
import ModalHelper from "../mixins/ModalHelper";
import IndexTables from "../mixins/IndexTables";

export default {
    name: 'ContractModal',
    components: {ContractStatus, ContractForm, TerminateContractForm, EditContractForm, WorkingHoursForm},
    mixins: [ RequestHandler, ModalHelper, IndexTables ],
    data() {
        return {
            loading: false,
            submitting: false,
            showHistory: false,

            action: null,
            contractId: null,
            data: {
                contractType: 'placement',
            },
        }
    },
    computed: {
        title() {
            const type = this.$trans.get(`__JSON__.${this.data.contractType}`)
            if (this.action === 'create') return this.$trans.get('__JSON__.Create :type contract', { type })
            else if (this.action === 'edit') return this.$trans.get('__JSON__.Edit :type contract', { type })
            else if (this.action === 'extend') return this.$trans.get('__JSON__.Extend :type contract', { type })
            else if (this.action === 'working-hours') return this.$trans.get('__JSON__.Edit working hours cap', { type })
            else if (this.action === 'terminate') return this.$trans.get('__JSON__.Terminate :type contract', { type })
            else return null
        },
        submitButton() {
            const type = this.data.contractType
            if (this.action === 'create') return this.$trans.get('__JSON__.Place')
            else if (this.action === 'edit') return this.$trans.get('__JSON__.Edit')
            else if (this.action === 'extend') return type === 'placement' ? this.$trans.get('__JSON__.Place') : this.$trans.get('__JSON__.Extend')
            else if (this.action === 'terminate') return this.$trans.get('__JSON__.Terminate')
            else return this.$trans.get('__JSON__.Save')
        },
        submitClass() {
            if (['terminate'].includes(this.action)) return 'btn-warning'
            else return 'btn-primary'
        },
    },
    methods: {
        fetch() {
            if (! this.action) return

            this.loading = true

            this.makeRequest('post', '/api/contracts', {
                action: this.action,
                contractId: this.contractId,
            }, response => this.data = response.data,
            error => console.log(error),
            () => this.loading = false
            )
        },
        submit() {
            this.submitting = true

            this.makeRequest('post', '/api/contracts/action', {
                action: this.action,
                contractId: this.contractId,
                ...this.$refs.form.$data.formData
            }, async response => {
                await window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('contractModal')).hide()
                await this.reloadTable()
            },
            error => console.error(error),
            () => this.submitting = false
            )
        },
    },
    mounted() {
        let vm = this
        let modal = document.getElementById('contractModal')

        modal.addEventListener('show.bs.offcanvas', event => {
            let trigger = event.relatedTarget
            vm.action = trigger.getAttribute('data-action') || 'create'
            vm.contractId = trigger.getAttribute('data-contract-id') || null
            vm.fetch()
        })

        modal.addEventListener('hide.bs.offcanvas', event => {
            vm.action = null
            vm.contractId = null
            vm.loading = false
            vm.showHistory = false
            vm.data = {
                contractType: 'placement',
            }
        })
    },
}
</script>
